import { RollbackOutlined, TeamOutlined } from '@ant-design/icons';
import { useUserContext } from '@threatadvisor/react-components';
import { Button, Empty, Space, Typography } from 'antd';
import React, { ReactElement } from 'react';

export default function NotFound(props): ReactElement {
  const oidcUser = useUserContext();

  function openEmail() {
    const recipient = 'support@threatadvisor.com';
    const subject = 'Client Portal 404 Issue';
    const body =
      `I am trying to access a specific page on the website, but I am getting a 404 error. ` +
      `The page I am trying to access is ${window.location}. ` +
      `Can you please look into this and let me know what's causing the error and how to fix it?`;
    window.location.href = `mailto:${recipient}?cc=${oidcUser.oidcUser.email}&subject=${subject}&body=${body}`;
  }

  return (
    <div className="pageContainer">
      <Space
        direction="horizontal"
        style={{ height: '90%', width: '85%', justifyContent: 'center', alignItems: 'center' }}
      >
        <Empty description="" />
        <Space direction="vertical">
          <Typography.Title level={1}>404 Page Not Found</Typography.Title>
          <Typography.Text>The URL doesn't match any of our pages.</Typography.Text>
          <Space direction="horizontal">
            <Button
              type="default"
              ghost
              onClick={() => window.history.back()}
              icon={<RollbackOutlined />}
            >
              Go Back
            </Button>
            <Button type="default" ghost onClick={openEmail} icon={<TeamOutlined />}>
              Contact Support
            </Button>
          </Space>
        </Space>
      </Space>
    </div>
  );
}
